import Moment from "react-moment";
import React from "react";

function DateCell({ value }: any) {
  return <Moment date={value} format={"DD/MM/YYYY"} />;
}

export default DateCell;
